import axios from 'axios';
import authHeader from './auth-header';
import getUser from './get-user';
import jwt_decode from 'jwt-decode';

const API_URL = 'https://sotira-back-test.herokuapp.com/';
//const API_URL = "http://localhost:8080/";
class UserService {

  getExpense() {
    //console.log("get expense call");
    return axios.get(API_URL + 'expense/get_expense', { params: getUser() });
  }

  getSale() {
    // console.log("get sale call");
    return axios.get(API_URL + 'sale/get_sale', { params: getUser() });
  }

  async getIncome() {
    //console.log("get income call");
    return axios.get(API_URL + 'income/get_income', { params:getUser() }); //.then((response)=>response.data);
  }

  addSalesGoal(userID,saleGoal,salesGoalTime,incomeStream){
    const params = {
      userID: userID,
      saleGoal:saleGoal,
      saleGoalTime:salesGoalTime,
      incomeStream:incomeStream
    }
    return axios.post(API_URL + 'income/add_sales_goal', params);
  }

  addExpenseCap(userID,expCap,expCapTime,incomeStream){
    const params = {
      userID: userID,
      expCap:expCap,
      expCapTime:expCapTime,
      incomeStream:incomeStream
    }
    return axios.post(API_URL + 'income/add_expense_cap', params);
  }

  getEtsyToken() {
    return axios.get(API_URL + 'etsy/get_token', { params: getUser() });
  }

  getResetTasks() {
    return axios.get(API_URL + 'admin/reset_tasks', { params: getUser() });
  }

  addEtsyToken(token) {
    const params = {
      userID: getUser().userID,
      accessToken: token
    }

    return axios.post(API_URL + 'etsy/add_token', params);
  }

  generateEtsyUrl() {
    return axios.post(API_URL + 'etsy/generate_url', { params: getUser() });
  }

  getEtsyData(){
    return axios.get(API_URL + 'etsy/welcome', { params: getUser() });
  }

  getShopsData(){
    return axios.get(API_URL + 'etsy/get_shops', { params: getUser() });
  }

  getSpecificExpense(data, stream){
    const expenses = new Array();
    //console.log(data);
    for (let i of data){
      //console.log("test");
      //console.log(data);
      if (i.incomeStream == stream){
        i.realDate = i.date;
        i.date = new Date(i.date).toDateString().toString();
        expenses.push(i);
      }
    }
    //console.log(expenses);
    return expenses;
  }

  getSpecificSale(data, stream){
    const sale = new Array();
    //console.log(data);
    for (let i of data){
      //console.log("test");
      //console.log(data);
      if (i.incomeStream == stream){
        i.realDate = i.date;
        i.date = new Date(i.date).toDateString().toString();
        sale.push(i);
      }
    }
    //console.log(expenses);
    return sale;
  }


  makeIncomeArray(name, source, revenue, note, expenses, sales){
    function createData(name, source, revenue, note, expenses, sales ) {
      return { name, source, revenue, note, expenses, sales};
    }
    const newData = new Array();
    //console.log(name);
    //console.log(source);
    //console.log(revenue);
    //console.log(note);
    //console.log(expenses);
    for (let i in name){
      newData.push(createData(name[i], source[i], revenue[i], note[i], expenses[i], sales[i]));
    }
    return newData;
  }

  makeCardArray(name, amount){
    function createcardData(name, amount ) {
      return { name, amount};
    }
  const cardData = new Array();
   for (let i in name){
      cardData.push(createcardData(name[i], amount[i]));
    }
    return cardData;
  }

  getTutStatus() {
      return axios.get(API_URL + 'user/get_tut_stat', { params: getUser() });
  }

  getUserName() {
    return axios.get(API_URL + 'user/get_name', { params: getUser() });
  }

  tutorialDone(userID) {
    return axios.post(API_URL  + 'user/tutorial_done', {
      userID: userID.id
    });
  }

  onBoardingAnswer() {
    return axios.get(API_URL  + 'user/onboarding_answers', { params: getUser() });
  }

  getReferral() {
    return axios.get(API_URL + 'user/get_referral_code', { params: getUser() });
  }

  onBoardingQuestionsDone(userID, timeType, platforms, sellerType, profit, goal) {
    return axios.post(API_URL + 'user/onboarding_done', {
      userID: userID.id,
      timeType,
      platforms,
      sellerType,
      profit,
      goal
    });
  }

  onBoardingTasksCheck() {
    return axios.get(API_URL + 'user/get_onboard_tasks', { params: getUser() });
  }

  onBoardingQuestionsCheck() {
    return axios.get(API_URL + 'user/get_onboard_stat', { params: getUser() });
  }

  onBoardingTaskBuisCheck() {
    return axios.get(API_URL + 'user/onboarding_add_buis', { params: getUser() });
  }

  onBoardingTaskExpCheck() {
    return axios.get(API_URL + 'user/onboarding_add_expense', { params: getUser() });
  }

  onBoardingTaskSaleCheck() {
    return axios.get(API_URL + 'user/onboarding_add_sale', { params: getUser() });
  }

  changeName(userID,firstName,lastName){
    const params = {
      userID: userID,
      firstName:firstName,
      lastName:lastName
    }
    return axios.post(API_URL + 'user/change_name', params);
  }

  changeEmail(userID,email,password){
    const params = {
      userID: userID,
      email:email,
      password:password
    }
    return axios.post(API_URL + 'user/change_email', params);
  }

  changenewPassword(userID,password,newPassword){
    const params = {
      userID: userID,
      password:password,
      newPassword:newPassword
    }
    return axios.post(API_URL + 'user/newPass', params);
  }

}

export default new UserService();
